export default "__VITE_ASSET__DKsd00oo__"